export const DS_STATE_CLASSES = {
  Disabled: "is-disabled",
  Error: "is-error",
  InlineEdit: "is-inline-edit",
  Selected: "is-selected",
} as const;
